import axios from 'axios'
import PMBImageWithToken from 'components/PMBImageWithToken'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody, CardText } from 'reactstrap'

const PaymentInfo = ({ detail }) => {
  const [isOpenModalPreview, setIsOpenModalPreview] = useState(false)
  const [urlImage, setUrlImage] = useState([])
  const { token } = useSelector((s) => s.auth)

  const onShowImagePreview = async (item) => {
    try {
      setUrlImage([item])
      setIsOpenModalPreview(true)
    } catch (error) {
      console.error('Terjadi kesalahan saat memuat file dengan token', error)
    }
  }

  return (
    <>
      <PMBModalImagePreview
        isOpen={isOpenModalPreview}
        toggle={() => {
          setIsOpenModalPreview(false)
          setUrlImage([])
        }}
        images={urlImage}
        isDownload
      />
      {detail?.orderDetail?.autoRelease && (
        <Card className="w-100 mb-3">
          <CardBody>
            <CardText tag="h6"> Bukti Barang Diterima</CardText>
            <div className="d-flex gap-2 flex-column">
              {detail?.orderDetail?.escrowFiles?.length > 0 &&
                detail?.orderDetail?.escrowFiles.map((el, i) => (
                  <PMBImageWithToken
                    noToken
                    key={i}
                    source={el}
                    token={token}
                    alt="Bukti Barang Diterima"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      onShowImagePreview(el)
                    }}
                  />
                ))}
            </div>
          </CardBody>
        </Card>
      )}
      {detail?.orderDetail?.proofOfPayment?.length > 0 && (
        <Card className="w-100 mb-3">
          <CardBody>
            <CardText tag="h6"> Bukti Pembayaran</CardText>
            <div className="d-flex gap-2 flex-column">
              {detail?.orderDetail?.proofOfPayment?.length > 0 &&
                detail?.orderDetail?.proofOfPayment.map((el, i) => (
                  <PMBImageWithToken
                    noToken
                    key={i}
                    testId={`order-proof-image-${i}`}
                    source={el}
                    token={token}
                    alt="Bukti Pembayaran"
                    className="rounded"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      onShowImagePreview(el)
                    }}
                  />
                ))}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default PaymentInfo
